import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_SUBMIT_SPE_ADDITIONAL_DETAILS } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface SubmitSPEAdditionalDetailsRequest {
  intendedResidentialZone: string;
  overseasResidenceCity: string;
  overseasResidenceCountry: string;
  overseasResidenceState: string;
  overseasResidencePeriodOfResidenceFrom: string;
  overseasResidencePeriodOfResidenceTo: string;
  passportNo: string;
  nricFinPassport: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSubmitSPEAdditionalDetails = ({ uuid, onSuccess, onError }: Input) => {
  const postSubmitSPEAdditionalDetails = async (reqBody: SubmitSPEAdditionalDetailsRequest) => {
    await axiosClient.post(POST_SUBMIT_SPE_ADDITIONAL_DETAILS(uuid), reqBody);
  };

  return useCustomMutation(postSubmitSPEAdditionalDetails, {
    onSuccess,
    onError,
  });
};
